import commonMixin from '../../mixins/_common';
import flashMessageMixin from '../../mixins/_flash_messages';
import editedFlagMixin from '../../mixins/_edited_flag';
import deployBtnsComponent from './_deploy_btns_component';
import staticHtmlEditor from '../../components/static_html_editor/_index';
import KanbanStaticHtmlEditor from './_edit_kanban';
import editHistory from '../../components/static_html_editor/_edit_history';

// 各エリア定義
const AREAS_DATA = [
    {
        key: 'freetext',
        name: 'PCトップ',
        width: 1090,
    },
    {
        key: 'spfreetext1',
        name: 'スマホトップ',
        width: 480,
    },
    {
        key: 'header',
        name: '看板',
        width: 1180,
    },
    {
        key: 'footer',
        name: 'フッター',
        width: 1090,
    },
];

/**
 * ストアページ編集コンポーネント
 */
export default {
    name: 'Edit',
    template: '#edit_template',
    data() {
        return {};
    },
    props: {
        // 編集ID
        edit_id: {
            type: [String, Number],
            require: true
        },
        // 全データ
        prop_template: {
            type: Object,
            required: true
        },
        // 編集ブロック
        prop_edit_area: '',
        // 編集データ
        prop_edit_data: {
            type: Object,
            default: () => ({}),
        },
        // 連動フラグ
        prop_device_sync: {
            type: Boolean,
            required: true
        },
    },
    components: {
        'deploy-btns-component': deployBtnsComponent,
        // 静的HTML編集コンポーネント
        'static-html-editor': staticHtmlEditor,
        // 看板用の静的HTML編集コンポーネント
        'kanban-static-html-editor': KanbanStaticHtmlEditor,
        // Undo / Redoコンポーネント
        'edit-history': editHistory,
    },
    computed: {
        template: {
            get() {
                return this.prop_template;
            },
            set(value) {
                this.$emit('update:prop_template', value);
            },
        },
        // 編集ブロック(このコンポーネント用)
        editArea: {
            get() {
                return this.prop_edit_area;
            },
            set(value) {
                this.$emit('update:prop_edit_area', value);
            },
        },
        // 編集データ(このコンポーネント用)
        editData: {
            get() {
                return this.prop_edit_data;
            },
            set(value) {
                this.$emit('update:prop_edit_data', value);
            },
        },
        // 各エリア定義
        areasConfig: function () {
            return AREAS_DATA;
        },
        // 編集エリアデータリスト
        areasData: function () {
            let areasData = _.cloneDeep(AREAS_DATA);
            // スマホ連動時調整
            if (this.device_sync) {
                areasData[0].name = 'PC & スマホトップ';
                areasData.splice(1, 1);
            }
            return areasData.map((area) => {
                area.no_name = area.name;
                return area;
            });
        },
        // 選択されている編集エリア
        areaData: function () {
            for (let area of this.areasData) {
                if (area.key === this.editArea) {
                    return area;
                }
            }
            return '';
        },
        device_sync: {
            get() {
                return this.prop_device_sync;
            },
            set(value) {
                this.$emit('update:prop_device_sync', value);
            },
        }
    },
    mixins: [
        commonMixin,
        flashMessageMixin,
        editedFlagMixin
    ],
    emits: [
        'update:prop_template',
        'update:prop_edit_area',
        'update:prop_edit_data',
        'update:prop_device_sync',
        'update:template',
    ],
    watch: {
        // 編集完了時処理
        edited: function (value) {
            if (value === false) this.$refs.editHistory.clearHistory();
        },
    },
    created: function () {
        // 初期編集エリアセット
        this.iniEditArea();
        // 未保存アラート機能初期化(templateを対象とする)
        this.iniEditedFlag('template');
    },
    methods: {
        // プレビューモーダルを開く
        openPreview: function (template) {
            this.$root.$refs.preview.show(template);
        },
        // 初期編集エリアに切り替える(エリア定義リストの1つめ)
        iniEditArea: function () {
            this.editArea = this.areasData[0].key;
        },
        // トップメニューに戻る
        backToMenu: async function () {
            if (await this.destConfirm()) {
                window.location.href = '/menu';
            }
        },
        // 「テンプレートを選び直す」リンク選択
        selectStoreTemplate: function () {
            this.$parent.$refs.modal_store_template_change.open();
        },
        // 静的HTMLを更新する(staticHtmlEditor.getStaticHtml()の実行)
        getRefStaticHtml: async function () {
            await this.iniEditArea();
            this.$refs.staticHtmlEditor.getStaticHtml();
        },

        // -------------------------
        // emit
        // -------------------------

        // template更新
        emitUpdateTemplate: function (template) {
            template = Object.assign({}, this.template, template);
            this.$emit('update:template', template);
        },
    }
};
